import * as actionTypes from "./TasksTypes";

const INITIAL_STATE = {
    tasksList: [],
    taskStatusList: [],
    employeeList: [],
    superUser: null,
    task: null
};

const TasksReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETTASKSLIST:
            return {
                ...state,
                tasksList: action.payload.list,
            };
        case actionTypes.SETTASKSTATUSLIST:
            return {
                ...state,
                taskStatusList: action.payload.list,
            };
        case actionTypes.SETEMPLOYEELIST:
            return {
                ...state,
                employeeList: action.payload.list,
            };
        case actionTypes.SETSUPERUSER:
            return {
                ...state,
                superUser: action.payload.data,
            };
        case actionTypes.SETTASK:
            return {
                ...state,
                task: action.payload.data,
            };
        default:
            return state;
    }
}

export default TasksReducer;